import { motion } from "framer-motion";
import { Smartphone, SlidersHorizontal, Network } from "lucide-react";

const steps = [
  { icon: Smartphone, t: "Multi-device", d: "Expanding to Android flagships and the iPad Pro ecosystem." },
  { icon: SlidersHorizontal, t: "Modular tools", d: "Interchangeable tips and integrated sensors for advanced creators." },
  { icon: Network, t: "Full ecosystem", d: "A complete suite of mobile productivity hardware and software." },
];

export const GrowthVision = () => (
  <section id="vision" data-testid="vision-section" className="py-24 md:py-32 bg-stone-900 text-stone-50">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="max-w-2xl mb-16">
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-stone-400 mb-6">The vision</p>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-tight">
          This is the beginning of <span className="italic">a new category.</span>
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {steps.map((s, i) => (
          <motion.div
            key={s.t}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            data-testid={`vision-${i}`}
            className="p-8 rounded-2xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] transition-colors"
          >
            <s.icon className="w-8 h-8 mb-6" strokeWidth={1.5} />
            <div className="text-sm text-stone-500 mb-2">0{i + 1}</div>
            <h3 className="text-xl font-bold mb-3">{s.t}</h3>
            <p className="text-stone-400 leading-relaxed">{s.d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
